import { Component, OnInit } from '@angular/core';
import { Certifications } from './constants/certifications.const';

@Component({
  selector: 'louver-certification-dialog',
  templateUrl: './louver-certification-dialog.component.html',
  styleUrls: ['./louver-certification-dialog.component.scss'],
  standalone: false,
})
export class LouverCertificationDialogComponent implements OnInit {
  dataSource = Certifications;

  constructor() {}

  ngOnInit() {}
}
